import { render } from "./FormAddTree.vue?vue&type=template&id=0644115a"
import script from "./FormAddTree.vue?vue&type=script&lang=js"
export * from "./FormAddTree.vue?vue&type=script&lang=js"

import "./FormAddTree.vue?vue&type=style&index=0&id=0644115a&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__